import { ParsedUrlQuery } from 'querystring'

export interface FilterTypes {
  price: string | null
  brand_id: string | null
  country_of_origin: string | null
  daily_availability_plan: string | null
  show_unavailable_products: boolean | null
  favourite_products: boolean | null
  tag: string[] | null
  multipack: boolean | null
}

export type FilterValues = Partial<FilterTypes>

interface FilterQueryTypes {
  sort_by: string
  category: string
  order: string
  entity: string[]
  page: number
  filter: Partial<FilterTypes>
}

export const parseQueryFilters = (input: ParsedUrlQuery) => {
  const result: Partial<FilterQueryTypes> = {}

  for (const key in input) {
    const value = input[key]

    const keys = key.split('[').map(k => k.replace(']', ''))

    let currentObj = result

    for (let i = 0; i < keys.length; i++) {
      const k = keys[i]

      if (i === keys.length - 1) {
        if (Array.isArray(currentObj)) {
          currentObj.push(value)
        } else if (
          typeof value === 'boolean' ||
          value === 'true' ||
          value === 'false'
        ) {
          currentObj[k] =
            value === 'true' ? true : value === 'false' ? false : value
        } else {
          currentObj[k] = value
        }
      } else {
        if (!currentObj[k]) {
          currentObj[k] =
            keys[i + 1] && !isNaN(Number(keys[String(i + 1)])) ? [] : {}
        }

        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        currentObj = currentObj[k]
      }
    }
  }

  return result
}

export const mapUrlToPromotedUpselling = (routeSegments: string[] | string) => {
  return routeSegments.includes('promocje') ? 'upsellingZone/promoted' : null
}
